export const division = {
	TEST:2946080,
	PROD:2283159
};

export const curdiv = division.PROD;